import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { usePrecosRotas, ORIGEM, brl } from '../lib/precosRotas';

// Cartão sobre a foto: mostra em segundos o que a plataforma faz (rota real, preço calculado ao vivo)
const CartaoExemplo = () => {
  const rotas = usePrecosRotas();
  const sp = rotas && rotas[0];
  return (
    <div className="absolute left-1/2 top-[52%] -translate-x-1/2 -translate-y-1/2 w-[290px] sm:w-[330px] bg-white rounded-3xl p-5 sm:p-6 shadow-[0_30px_70px_rgba(15,23,42,0.25)]">
      <span className="absolute -right-3 -top-4 bg-[#16A34A] text-white text-[13px] font-black rounded-full px-3 py-2 shadow-[0_8px_18px_rgba(22,163,74,0.35)]">Preço de contrato</span>
      <p className="text-[15px] text-slate-500 font-bold mb-3">Simule em segundos</p>
      <div className="flex justify-between items-center border border-slate-200 rounded-2xl px-4 py-3 mb-2.5 text-sm"><span className="text-[#2A5BC7] font-extrabold">De</span><b className="text-slate-700">{ORIGEM.nome} - {ORIGEM.uf}</b></div>
      <div className="flex justify-between items-center border border-slate-200 rounded-2xl px-4 py-3 mb-2.5 text-sm"><span className="text-[#2A5BC7] font-extrabold">Para</span><b className="text-slate-700">{sp ? `${sp.nome} - ${sp.uf}` : 'São Paulo - SP'}</b></div>
      <Link to="/calcular" className="block text-center bg-[#F77820] hover:bg-[#e86a12] text-white rounded-2xl py-3 font-extrabold text-[13.5px] tracking-wide mt-1.5 mb-3.5">CALCULAR FRETE COM DESCONTO</Link>
      <div className="flex justify-between items-end border-t border-dashed border-slate-300 pt-3">
        <div>
          <span className="block text-[13px] text-slate-500 font-bold">PAC com desconto</span>
          {sp && sp.balcao > sp.valor && <span className="block text-xs text-slate-400 line-through">Balcão R$ {brl(sp.balcao)}</span>}
        </div>
        {sp
          ? <div className="text-[34px] sm:text-[40px] font-black text-[#1E429F] leading-none"><sup className="text-base mr-0.5">R$</sup>{brl(sp.valor)}</div>
          : <div className="text-sm font-bold text-[#1E429F]">Calcule o seu →</div>}
      </div>
    </div>
  );
};

const Hero = () => (
  <section className="relative overflow-hidden bg-white">
    <div className="max-w-[1240px] mx-auto px-5 lg:px-8 grid lg:grid-cols-[1.05fr_1fr] items-center gap-4 lg:gap-10 pb-12 lg:min-h-[calc(100vh-92px)]">
      <div className="relative h-[430px] lg:h-[600px] order-2 lg:order-1">
        <div className="absolute w-[70px] h-[70px] lg:w-[90px] lg:h-[90px] rounded-full bg-[#F77820] opacity-90 left-0 top-10 lg:top-[60px]" />
        <div className="absolute w-[46px] h-[46px] rounded-full bg-[#2A5BC7] opacity-85 right-5 bottom-10" />
        <div className="absolute inset-[30px_10px_20px_0] lg:inset-[40px_30px_30px_10px] overflow-hidden shadow-[0_30px_60px_rgba(30,66,159,0.25)]" style={{ borderRadius: '46% 54% 48% 52% / 52% 44% 56% 48%' }}>
          <img src="/img/login-envios.webp" alt="" aria-hidden="true" className="w-full h-full object-cover object-[58%_center]" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1E429F]/35 to-transparent" />
        </div>
        <CartaoExemplo />
      </div>
      <div className="order-1 lg:order-2 pt-4 lg:pt-0">
        <h1 className="text-[38px] sm:text-5xl lg:text-[62px] font-black leading-[1.04] tracking-tight text-slate-900">
          Calcular frete e emitir com <span className="inn-text-gradient">desconto</span>
        </h1>
        <p className="mt-4 lg:mt-6 mb-6 lg:mb-9 text-[17px] lg:text-[22px] leading-relaxed text-slate-600 max-w-[520px]">
          Envie <strong className="text-slate-900">PAC e SEDEX pagando menos</strong> que no balcão dos Correios. Sem mensalidade.
        </p>
        <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-4 sm:gap-6">
          <Link to="/calcular" className="inline-flex justify-center items-center gap-2 bg-[#F77820] hover:bg-[#e86a12] text-white font-extrabold rounded-full px-8 lg:px-10 py-4 lg:py-5 text-base lg:text-[19px] whitespace-nowrap shadow-[0_10px_24px_rgba(247,120,32,0.28)]">
            Emitir frete com desconto <ArrowRight className="w-5 h-5" />
          </Link>
          <a href="#economia" className="text-center text-[#2A5BC7] font-extrabold hover:underline whitespace-nowrap">ver quanto você economiza</a>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 mt-6 lg:mt-9 text-slate-500 font-bold text-[13.5px] lg:text-[14.5px]">
          {['Sem mensalidade', 'Etiqueta na hora', 'Suporte humanizado'].map((t) => (
            <span key={t} className="flex items-center gap-2"><i className="w-2 h-2 rounded-full bg-[#2A5BC7] inline-block" />{t}</span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
